export const LAYOUT_SET_WINDOW_SIZE = "LAYOUT_SET_WINDOW_SIZE";

export function setWindowSize(size) {
	return {
		type: LAYOUT_SET_WINDOW_SIZE,
		data: size,
	};
}
